export default __webpack_public_path__ + "static/media/spoonsButton.23ec0509.png";